export type ThemeMode = 'light' | 'dark' | 'system';

export const THEME_STORAGE_KEY = 'theme';

export function themeModeFromStorageValue(value: unknown): ThemeMode {
  if (value === 'light' || value === 'dark' || value === 'system') {
    return value;
  }
  return 'system';
}

export function isThemeStorageEvent(
  event: Pick<StorageEvent, 'key' | 'storageArea'>,
  store?: Storage | null,
): boolean {
  if (event.storageArea != null && store != null && event.storageArea !== store) {
    return false;
  }
  return event.key === THEME_STORAGE_KEY || event.key === null;
}
